import React from 'react';
import _ from 'lodash';
import { ButtonGroup, Button, ButtonOr } from 'semantic-ui-react';
import { FormFieldProp } from '../../../enum/apiResultProp/FormFieldProp';
import { ButtonOptionsFormFieldOptionProp } from '../../../enum/apiResultProp/buttonOptionsForm/ButtonOptionsFormFieldOptionProp';
import CustomPopup from '../../widgets/CustomPopup';
import { EventProp } from '../../../enum/apiResultProp/EventProp';
import { ActionProp } from '../../../enum/apiResultProp/ActionProp';
import { ActionType } from '../../../enum/ActionType';

export default ({ fieldProps, onValueChange, onActionMutateScreenWithPostDataOnButtonClick, tableFormRowKey, hasSpinner }) => {
    const name = fieldProps[FormFieldProp.Name];
    const options = fieldProps[FormFieldProp.Options];
    const selectedValues = fieldProps[FormFieldProp.Value];
    const isReadOnly = fieldProps[FormFieldProp.IsReadOnly];

    const countOfOptions = options.length;
    let currentOption = 0;

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ButtonGroup >
                {
                    _.map(options, option => {
                        currentOption++;
                        const key = option[ButtonOptionsFormFieldOptionProp.Key];
                        const optionValue = option[ButtonOptionsFormFieldOptionProp.Value];
                        const text = option[ButtonOptionsFormFieldOptionProp.Text];
                        const selectedColor = option[ButtonOptionsFormFieldOptionProp.SelectedColor];
                        const notSelectedColor = option[ButtonOptionsFormFieldOptionProp.NotSelectedColor];
                        const popup = option[ButtonOptionsFormFieldOptionProp.Popup];
                        const onClickEvent = option[ButtonOptionsFormFieldOptionProp.OnClickEvent];
                        const disableWhenClicked = option[ButtonOptionsFormFieldOptionProp.DisableWhenClicked];

                        let color = selectedValues === optionValue ? selectedColor : notSelectedColor;

                        const isChecked = _.indexOf(selectedValues, optionValue) !== -1;

                        const onClick = async () => {
                            let shouldRun = true;
                            if (isChecked && disableWhenClicked) {
                                shouldRun = false;
                            }

                            if (shouldRun) {
                                let newValues;

                                if (isChecked) {
                                    newValues = _.without(selectedValues, optionValue);
                                } else {
                                    newValues = [...selectedValues, optionValue];
                                }

                                await onValueChange({ value: newValues });

                                if (onClickEvent) {
                                    const action = onClickEvent[EventProp.Action];

                                    if (action) {
                                        const actionType = action[ActionProp.ActionType];

                                        if (actionType === ActionType.MutateScreenWithPostDataAction) {
                                            const backEndUrl = action[ActionProp.BackEndUrl];
                                            onActionMutateScreenWithPostDataOnButtonClick({ backEndUrl: backEndUrl, rowKey: tableFormRowKey, hasSpinner: hasSpinner });
                                        }
                                    }
                                }
                            }
                        };

                        let button = (
                            <Button primary={isChecked} disabled={isReadOnly} color={color} onClick={onClick}>{text}</Button>
                        );

                        if (popup) {
                            button = <CustomPopup popupProps={popup} triggerComponent={button} />
                        }

                        return (
                            <React.Fragment key={key}>
                                {button}
                                {currentOption !== countOfOptions ? <ButtonOr text='|' /> : null}
                            </React.Fragment>
                        );
                    })
                }


            </ButtonGroup>
        </div>
    );
}
